// Require

const { id, log, min, limit } = require("../std/index")


//
// Slice Debugger
//
// Helps visualise what's actually going on in the fancy scrolling homepage, cos
// it's confusing as hell.
//

class SliceDebugger {
  constructor(docHeight, viewportHeight, host) {
    this.COLOR_TCB_GREEN = '#afbd21';

    this.canvas = document.createElement('canvas');
    $(this.canvas).css({ position: 'fixed', top: 0, left: 0, 'z-index': 2, background: 'white' });
    this.ctx = this.canvas.getContext('2d');

    this.slices = [];

    this.setDimensions(docHeight, viewportHeight);
    this.install(host);
  }

  screenToCanvas(px) {
    return px / this.docHeight * this.h;
  }

  setDimensions(docHeight, viewportHeight) {
    this.docHeight = docHeight;
    this.viewportHeight = viewportHeight;
    this.canvas.height = this.h = min(viewportHeight, docHeight);
    this.canvas.width = this.w = 29;
    this.virtualScreenHeight = viewportHeight / docHeight * this.h;
  }

  addSlice(slice) {
    const sliceProps = slice.getDimensions();
    sliceProps.color = this.COLOR_TCB_GREEN;
    this.slices.push(sliceProps);
  }

  clear() {
    this.ctx.globalAlpha = 1;
    this.ctx.fillStyle = 'white';
    this.ctx.fillRect(0, 0, this.w, this.h);
  }

  setOffset(px, p) {
    this.clear();
    this.ctx.lineWidth = 1;
    this.ctx.strokeStyle = 'black';

    for (const slice of this.slices) {
      this.ctx.globalAlpha = 0.3;
      this.ctx.fillStyle = 'grey';
      this.ctx.fillRect(0, this.screenToCanvas(slice.offset), this.w, this.screenToCanvas(slice.scrollHeight));

      this.ctx.fillStyle = slice.color;
      this.ctx.fillRect(0, this.screenToCanvas(slice.offset), this.w, this.screenToCanvas(slice.height));

      this.ctx.globalAlpha = 1;

      for (let i = 0; i < slice.scrollFactor; i++) {
        this.ctx.fillRect(0, this.screenToCanvas(slice.offset + i * slice.height / slice.scrollFactor), this.w * (-i + limit(i, i + 1, slice.progress)), this.screenToCanvas(slice.height / slice.scrollFactor));
      }

      this.ctx.beginPath();
      this.ctx.moveTo(0, this.screenToCanvas(slice.offset));
      this.ctx.lineTo(this.w, this.screenToCanvas(slice.offset));
      this.ctx.moveTo(0, this.screenToCanvas(slice.offset) + this.screenToCanvas(slice.scrollHeight));
      this.ctx.lineTo(this.w, this.screenToCanvas(slice.offset) + this.screenToCanvas(slice.scrollHeight));
      this.ctx.closePath();
      this.ctx.stroke();
    }

    this.ctx.globalAlpha = 0.1;
    this.ctx.fillStyle = 'black';
    this.ctx.fillRect(0, this.screenToCanvas(px), this.w, this.virtualScreenHeight);
  }

  install(host) {
    host.appendChild(this.canvas);
  }
}

module.exports = { SliceDebugger };
